import { __rest } from '../../../../../../_virtual/_tslib.js';
import React from 'react';
import { GlobalNavStyles, StyledNavbar } from './Navbar.styles.js';
import NavbarLogo from './NavbarLogo.js';
import { NavbarProvider } from './NavbarContext.js';
import { useWindowWidth } from '@lwt-helix/useWindowWidth';
import NavbarMobileMenu from './NavbarMobileMenu.js';
import NavbarExpandButton from './NavbarExpandButton.js';

var Navbar = function Navbar(_a) {
  var applicationName = _a.applicationName,
      _a$logoUrl = _a.logoUrl,
      logoUrl = _a$logoUrl === void 0 ? '/' : _a$logoUrl,
      children = _a.children,
      _a$isDark = _a.isDark,
      isDark = _a$isDark === void 0 ? false : _a$isDark,
      _a$fixed = _a.fixed,
      fixed = _a$fixed === void 0 ? false : _a$fixed,
      className = _a.className,
      dataLwtId = _a.dataLwtId,
      _a$hideLogo = _a.hideLogo,
      hideLogo = _a$hideLogo === void 0 ? false : _a$hideLogo,
      _a$hideLogoOnMobile = _a.hideLogoOnMobile,
      hideLogoOnMobile = _a$hideLogoOnMobile === void 0 ? false : _a$hideLogoOnMobile,
      logoLinkWrapper = _a.logoLinkWrapper,
      onExpandIconClick = _a.onExpandIconClick,
      expandIconActive = _a.expandIconActive,
      customMobileMenu = _a.customMobileMenu,
      _a$mobileMenuOpen = _a.mobileMenuOpen,
      mobileMenuOpen = _a$mobileMenuOpen === void 0 ? false : _a$mobileMenuOpen,
      _onMobileMenuToggle = _a.onMobileMenuToggle,
      rest = __rest(_a, ["applicationName", "logoUrl", "children", "isDark", "fixed", "className", "dataLwtId", "hideLogo", "hideLogoOnMobile", "logoLinkWrapper", "onExpandIconClick", "expandIconActive", "customMobileMenu", "mobileMenuOpen", "onMobileMenuToggle"]);

  var _useWindowWidth = useWindowWidth(),
      windowWidth = _useWindowWidth.windowWidth;

  var reactChildren = children;
  var ReactChildrenArrayFirst = React.Children.toArray(children)[0]; // if the first child is a fragment check its children

  if (React.Children.count(children) === 1 && ReactChildrenArrayFirst.type === React.Fragment) {
    reactChildren = ReactChildrenArrayFirst.props.children;
  }

  var appSwitcher = React.Children.toArray(reactChildren).filter(function (child) {
    return child && child.type && child.type.displayName && child.type.displayName === 'ApplicationSwitcher' || child && child.props && child.props.originalType && child.props.originalType.displayName === 'ApplicationSwitcher';
  })[0];

  var hasBothNavbarBodyAndNavbarNavigationBar = function hasBothNavbarBodyAndNavbarNavigationBar() {
    var navbarBody = React.Children.toArray(reactChildren).filter(function (child) {
      return child && child.type && child.type.displayName && child.type.displayName === 'NavbarBody' || child && child.props && child.props.originalType && child.props.originalType.displayName === 'NavbarBody';
    })[0];
    var navbarNavigationBar = React.Children.toArray(reactChildren).filter(function (child) {
      return child && child.type && child.type.displayName && child.type.displayName === 'NavbarNavigationBar' || child && child.props && child.props.originalType && child.props.originalType.displayName === 'NavbarNavigationBar';
    })[0];
    return navbarBody && navbarNavigationBar;
  };

  return React.createElement(NavbarProvider, {
    hideLogo: hideLogo || hideLogoOnMobile && windowWidth < 576,
    logoUrl: logoUrl,
    isDark: isDark,
    isMobileMenuOpen: mobileMenuOpen,
    customMobileMenu: customMobileMenu,
    onMobileMenuToggle: function onMobileMenuToggle(isOpen) {
      return _onMobileMenuToggle && _onMobileMenuToggle(isOpen);
    }
  }, React.createElement(React.Fragment, null, React.createElement(GlobalNavStyles, null), React.createElement(StyledNavbar, Object.assign({
    className: "helix-unified-nav__nav ".concat(className ? className : ''),
    fixed: fixed,
    isDark: isDark,
    "data-lwt-id": dataLwtId,
    reducePaddingLeft: hasBothNavbarBodyAndNavbarNavigationBar(),
    hasExpandIcon: onExpandIconClick ? true : false
  }, rest), onExpandIconClick && windowWidth > 576 && React.createElement(NavbarExpandButton, {
    expandIconActive: expandIconActive,
    onExpandIconClick: onExpandIconClick
  }), React.createElement(NavbarLogo, {
    appSwitcher: appSwitcher,
    linkWrapper: logoLinkWrapper,
    applicationName: applicationName
  }), React.Children.map(reactChildren, function (child) {
    if (child && child.type && child.type.displayName && child.type.displayName !== 'ApplicationSwitcher') {
      return child;
    }
  }), windowWidth < 576 && React.createElement(NavbarMobileMenu, null))));
};

export { Navbar as default };